import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class PickerUserIcon extends BaseIcon {
    getChildren = () => {
        const color = this.getColor() === 'currentColor' ? '#2e3f58' : this.getColor()

        return [
            <g transform="translate(-3193 -4708)">
                <rect width="22" height="22" transform="translate(3193 4708)" fill="rgba(255,255,255,0)"/>
                <path d="M12,11.47c-1.84-.69-2.42-1.28-2.42-2.53,0-.75.56-.5.81-1.88.1-.57.59,0,.7-1.32,0-.52-.27-.65-.27-.65s.13-.77.19-1.36a2.694,2.694,0,0,0-3-2.64A2.676,2.676,0,0,0,5,3.73a5.279,5.279,0,0,0,.19,1.36S5,5.22,5,5.74c.1,1.31.59.74.7,1.32.24,1.37.8,1.13.8,1.88,0,1.26-.58,1.85-2.42,2.54s-3,1.4-3,1.88V15H15V13.36C15,12.88,13.8,12.17,12,11.47Z" transform="translate(3195.92 4710.91)" fill={color}/>
            </g>
        ]
    }
    getViewBox = () => '0 0 22 22'
}
